
import Vue from "vue";
import Component from "vue-class-component"; // 导入组件装饰器
import { getAuthorization } from "@/api/common";
import {
  formatDate,
  guid,
  getFileExtendingName,
  getYearMonthNow,
  getDateNow,
  domainURL,
} from "@/api/tools"; //导入相关工具
import { MarketReportFileApi } from "@/api/marketReportFileApi"; //导入配套接口API
import { MarketReportApi } from "@/api/marketReportApi"; //导入配套接口API
import {
  QueryForm,
  GetByPageData,
  GetByPageDataDetail,
  GetStsParam,
  UploadClass,
  AddDataDetail,
} from "@/models/marketReport/fileList"; //导入配套数据定义Model
import { downloadFile } from "@/utils/index";
import OSS from "ali-oss";

@Component({
  components: {},
  filters: {
    //过滤器格式化时间
    myFormatDate: function (time) {
      let date = new Date(time);
      return formatDate(date, "yyyy-MM-dd hh:mm:ss");
    },
    //从路径中获取文件名
    getFileName: function (path) {
      var obj = path.lastIndexOf("/");
      return path.substr(obj + 1);
    },
  },
}) // Component装饰器装饰类
export default class LeavingMsg extends Vue {
  // --------------------------------------------------------------数据区--------------------------------------------------------------
  name = "";
  reportId: any = "";
  typeName: any = "";
  $refs: Vue["$refs"] & {
    uploadFile: any;
    uploadPic: any;
  };
  multipleSelection = [];
  tableloading = false;
  rangeTime = "";
  // 新增、编辑Dialog
  isCreate = false;
  dialogReportListVisible = false;
  dialogReportListLoading = false;
  //上传相关
  isFile = false;
  isPic = false;
  isUploadPic = false;
  isUploadFile = false;
  fileSuccess = false;
  picSuccess = false;
  file = {};
  uploadListPic = [];
  uploadListFile = [];
  timestamp: any = new Date().getTime();
  expire: number = 0;
  client: any = null;
  uploadProgressFile: number = 0;
  uploadProgressPic: number = 0;
  alertMsgFile = "等待上传";
  alertMsgPic = "等待上传";
  alertTypeFile = "info";
  alertTypePic = "info";
  domainUrl = "";
  // 日期控件配置
  pickerOptions = {
    shortcuts: [
      {
        text: "最近一周",
        onClick(picker) {
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
          picker.$emit("pick", [start, end]);
        },
      },
      {
        text: "最近一个月",
        onClick(picker) {
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
          picker.$emit("pick", [start, end]);
        },
      },
      {
        text: "最近三个月",
        onClick(picker) {
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
          picker.$emit("pick", [start, end]);
        },
      },
    ],
  };
  pickerOptionsFile = {
    disabledDate(time) {
      return time.getTime() > Date.now();
    },
    shortcuts: [
      {
        text: "今天",
        onClick(picker) {
          picker.$emit("pick", new Date());
        },
      },
      {
        text: "昨天",
        onClick(picker) {
          const date = new Date();
          date.setTime(date.getTime() - 3600 * 1000 * 24);
          picker.$emit("pick", date);
        },
      },
      {
        text: "一周前",
        onClick(picker) {
          const date = new Date();
          date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
          picker.$emit("pick", date);
        },
      },
    ],
  };
  stsParam: GetStsParam = new GetStsParam();
  ossClient: UploadClass = new UploadClass();

  marketReport: MarketReportApi = new MarketReportApi();
  // 获取接口API
  marketReportFile: MarketReportFileApi = new MarketReportFileApi();
  // 列表数据-查询参数
  queryForm: QueryForm = new QueryForm();
  // 列表数据-查询结果数据格式
  getByPageData: GetByPageData = new GetByPageData();
  // 列表数据-查询结果数据格式-数据部分
  getByPageDataDetail: GetByPageDataDetail = new GetByPageDataDetail();
  // 新增-查询结果数据格式-数据部分
  addDataDetail: AddDataDetail = new AddDataDetail();
  rules: any = {
    reportName: [
      { required: true, message: "请输入报告文件名称", trigger: "blur" },
    ],
    reportDate: [
      { required: true, message: "请选择报告文件时间", trigger: "blur" },
    ],
    reportLink: [
      { required: true, validator: this.validReportFilePath, trigger: "blur" },
    ],
  };
  pdfFile: any = null;
  picFile: any = null;
  fileList: any = [];
  totalDownloadCount: number = 0;
  totalUniqueDownloaders: number = 0;
  reportType: number = 0;
  isOldReportType: number = 0;

  // 报告链接 验证
  validReportFilePath(rule: any, value: any, callback: any) {
    if (value === "" || value === null || value === undefined) {
      if (this.reportType === 1) {
        callback(new Error("请输入报告链接"));
        return false;
      } else {
        callback();
      }
    } else {
      callback();
    }
  }
  // --------------------------------------------------------------方法区----------------------------------------------------------------
  // 生命周期钩子
  created() {
    this.reportId = this.$route.query.id;
    this.typeName = this.$route.query.typeName;
    this.queryForm.marketReportTypeId = this.$route.query.id;
    this.onQuery(false);
    this.domainUrl = domainURL;
  }

  onSelectionChange(val) {
    this.multipleSelection = val;
  }
  // 批量导出下载记录
  onExportRecord() {
    if (this.multipleSelection.length <= 0) {
      return this.$message({
        showClose: true,
        type: "error",
        message: "请选择需要导出下载记录的文件！",
      });
    }
    let data = {
      reportIdList: this.multipleSelection.map((m) => m.id),
      queryDownLoadType: 0,
    };
    this.marketReport.exportDownloadRecord(data).then((res: any) => {
      // this.$message.success("下载成功!");
      downloadFile(res, this.typeName);
    });
  }

  onDownloadCommand(command, row) {
    switch (command) {
      case "lookRecord":
        this.$router.push(`/MarketReport/record/${row.id}/${row.reportName}`);
        break;
      case "exportRecord":
        this.onSingleExportRecord(row.id, row.reportName);
        break;
    }
  }
  // 单个导出下载记录
  onSingleExportRecord(id, reportName) {
    let data = {
      reportIdList: [id],
      queryDownLoadType: 1,
    };
    this.marketReport.exportDownloadRecord(data).then((res: any) => {
      this.$message.success("下载成功!");
      console.log(res);
      downloadFile(res, reportName);
    });
  }
  // 报告列表数据加载
  onQuery(isFlag: boolean = true) {
    this.tableloading = true;
    this.marketReportFile
      .getByPage(this.queryForm)
      .then((res: any) => {
        if (res.data) {
          this.getByPageData.tableData = res.data.pageData.data;
          this.getByPageData.total = res.data.pageData.total;
          this.totalDownloadCount = res.data.totalDownloadCount;
          this.totalUniqueDownloaders = res.data.totalUniqueDownloaders;
          if (isFlag) {
            this.$message({
              showClose: true,
              message: "查询成功",
              type: "success",
            });
          }
        } else {
          this.$message({
            showClose: true,
            message: "查询失败",
            type: "error",
          });
        }
        this.tableloading = false;
      })
      .catch((error) => {
        this.tableloading = false;
      });
  }
  // 报告种类新增
  onAdd() {
    this.isCreate = true;
    this.addDataDetail = new AddDataDetail();
    this.addDataDetail.marketReportTypeId = this.reportId;
    this.uploadListFile = [];
    this.uploadListPic = [];
    this.alertMsgFile = "等待上传";
    this.alertMsgPic = "等待上传";
    this.alertTypeFile = "info";
    this.alertTypePic = "info";
    this.uploadProgressFile = 0;
    this.uploadProgressPic = 0;
    this.dialogReportListVisible = true;
  }
  // 编辑报告种类
  onEdit(row) {
    this.isCreate = false;
    this.addDataDetail.reportName = row.reportName;
    this.addDataDetail.reportFilePath = row.reportFilePath;
    this.addDataDetail.reportPicPath = row.reportPicPath;
    this.addDataDetail.reportDate = row.reportDate;
    this.addDataDetail.reportLink = row.reportLink;
    this.addDataDetail.id = row.id;
    this.addDataDetail.marketReportTypeId = this.reportId;
    if (row.reportLink) {
      this.reportType = 1;
      this.isOldReportType = 1;
    } else {
      this.reportType = 0;
      this.isOldReportType = 0;
    }
    this.dialogReportListVisible = true;
  }
  radioChangFile(val) {
    if (val) {
      this.uploadListFile = [];
      this.alertMsgFile = "等待上传";
      this.alertTypeFile = "info";
      this.uploadProgressFile = 0;
    }
  }
  handleExceed(files, fileList) {
    this.$message.warning("当前限制选择 1 个文件，请先删除已选择的文件");
  }
  radioChangPic(val) {
    if (val) {
      this.uploadListPic = [];
      this.alertMsgPic = "等待上传";
      this.alertTypePic = "info";
      this.uploadProgressPic = 0;
    }
  }
  // 报告种类提交
  onSaveReportList() {
    (this.$refs.ReportListForm as any).validate((valid) => {
      if (valid) {
        this.fileSuccess = false;
        this.picSuccess = false;
        this.isFile = false;
        this.isPic = false;
        if (this.isCreate) {
          if (this.reportType === 0) {
            if (
              this.$refs.uploadFile.uploadFiles.length === 0 ||
              this.$refs.uploadPic.uploadFiles.length === 0
            ) {
              this.$message.warning("请上传文件或缩略图");
            } else {
              this.$refs.uploadFile.submit();
              this.$refs.uploadPic.submit();
              this.submit();
            }
          } else {
            if (this.$refs.uploadPic.uploadFiles.length === 0) {
              this.$message.warning("请上传缩略图");
            } else {
              this.$refs.uploadPic.submit();
              this.submit();
            }
          }
        } else {
          if (
            (this.isOldReportType === 1 && this.reportType === 0) ||
            this.addDataDetail.reUploadFile
          ) {
            if (this.$refs.uploadFile.uploadFiles.length === 0) {
              this.$message.warning("请上传文件");
              return false;
            } else {
              this.$refs.uploadFile.submit();
              this.addDataDetail.reUploadFile = true;
              this.addDataDetail.reportLink = "";
            }
          }
          if (this.reportType === 1) {
            this.addDataDetail.reportFilePath = "";
          }
          if (this.addDataDetail.reUploadPic) {
            if (this.$refs.uploadPic.uploadFiles.length === 0) {
              this.$message.warning("请上传缩略图");
              return false;
            } else {
              this.$refs.uploadPic.submit();
            }
          }
          this.submit();
        }
      }
    });
  }
  // 提交
  submit() {
    this.dialogReportListLoading = true;
    let data = new FormData();
    if (this.pdfFile) {
      data.append("pdfFile", this.pdfFile, this.pdfFile.name);
    }
    if (this.picFile) {
      data.append("picFile", this.picFile, this.picFile.name);
    }
    data.append("reportName", this.addDataDetail.reportName);
    data.append("reportFilePath", this.addDataDetail.reportFilePath);
    data.append("reportPicPath", this.addDataDetail.reportPicPath);
    data.append("reportDate", this.addDataDetail.reportDate);
    data.append("marketReportTypeId", this.addDataDetail.marketReportTypeId);
    data.append("reUploadFile", this.addDataDetail.reUploadFile);
    data.append("reUploadPic", this.addDataDetail.reUploadPic);
    data.append("reportLink", this.addDataDetail.reportLink);
    data.append("id", this.addDataDetail.id);
    if (this.isCreate) {
      this.marketReportFile.insertReportFileNew(data).then(
        (res: any) => {
          this.$message({
            showClose: true,
            message: "新增成功",
            type: "success",
          });
          this.dialogReportListVisible = false;
          this.dialogReportListLoading = false;
          this.onQuery(false);
        },
        () => {
          this.dialogReportListLoading = false;
        }
      );
    } else {
      this.marketReportFile.updateMarketReportFileNew(data).then(
        (res: any) => {
          this.$message({
            showClose: true,
            message: "编辑成功",
            type: "success",
          });
          this.dialogReportListVisible = false;
          this.dialogReportListLoading = false;
          this.onQuery(false);
        },
        () => {
          this.dialogReportListLoading = false;
        }
      );
    }
  }
  handleBeforeFile(file) {
    this.file = file;
  }
  handleBeforePic(file) {
    this.file = file;
  }
  // 文件上传
  submitUploadFile(params) {
    this.isFile = true;
    this.pdfFile = params.file;
    this.fileList.push(params.file);

    // this.isFile = true;
    // let vm = this;
    // vm.dialogReportListLoading = true;
    // return vm
    //   .setUploadParam()
    //   .then(async status => {
    //     if (status === 200) {
    //       // vm.isDisabled = true;
    //       this.multipartUpload(this.file);
    //     }
    //   })
    //   .catch(error => {
    //     this.$message.error("文件上传失败，请重试");
    //     this.dialogReportListLoading = false;
    //     //this.removeAllItems();
    //   });
    // // this.$refs.upload.submit();
  }
  // 图片上传
  submitUploadPic(params) {
    this.isPic = true;
    this.picFile = params.file;
    this.fileList.push(params.file);

    // this.isPic = true;
    // let vm = this;
    // vm.dialogReportListLoading = true;
    // return vm
    //   .setUploadParam()
    //   .then(async status => {
    //     if (status === 200) {
    //       // vm.isDisabled = true;
    //       this.multipartUpload(this.file);
    //     }
    //   })
    //   .catch(error => {
    //     this.$message.error("文件上传失败，请重试");
    //     this.dialogReportListLoading = false;
    //     //this.removeAllItems();
    //   });
    // // this.$refs.upload.submit();
  }
  // 开始上传
  async multipartUpload(param) {
    console.log("param------------", param);
    let vm = this;
    let ossClient = JSON.parse(sessionStorage.getItem("ossClient"));
    const storeAs =
      new Date().getFullYear() +
      "/" +
      getYearMonthNow() +
      "/" +
      getDateNow() +
      "/" +
      guid() +
      getFileExtendingName(param.name);
    vm.client = new OSS(ossClient);
    await vm.client
      .multipartUpload(storeAs, param, {
        progress: async function (percentage, cpt) {
          vm.uploadProgress = parseInt(percentage * 100);
        },
      })
      .then(async (result) => {
        // vm.isLoaderVisible = false;
        if (this.isFile) {
          vm.alertMsgFile = "上传成功！";
          vm.fileSuccess = true;
          // vm.dialogReportListLoading = false;
          vm.alertTypeFile = "success";
          this.addDataDetail.reportFilePath = result.name;
        }
        if (this.isPic) {
          vm.alertMsgPic = "上传成功！";
          vm.picSuccess = true;
          //vm.dialogReportListLoading = false;
          vm.alertTypePic = "success";
          this.addDataDetail.reportPicPath = result.name;
        }
        if (
          this.isCreate ||
          (this.addDataDetail.reUploadFile && this.addDataDetail.reUploadPic)
        ) {
          if (this.fileSuccess) {
            this.isFile = false;

            this.$refs.uploadPic.submit();
            if (this.picSuccess) {
              this.subMitType();
            }
          } else {
            this.$message.error("上传失败，请重试");
          }
        } else {
          this.subMitType();
        }

        //   vm.saveFile.fileName = param.name;
        //   vm.saveFile.fileSize = param.size;
        //   vm.saveFile.ossFilePath = result.name;
        //   vm.addFile(vm.saveFile);
      })
      .catch((err) => {
        if (!vm.client.isCancel()) {
          if (this.isFile) {
            vm.alertMsgFile = "上传失败";
            vm.alertTypeFile = "error";
            vm.uploadProgressFile = 0;
          } else {
            vm.alertMsgPic = "上传失败";
            vm.alertTypePic = "error";
            vm.uploadProgressPic = 0;
          }

          vm.dialogReportListLoading = false;
          //vm.removeAllItems();
        }
      });
  }
  // 文件上传之前判断签名是否过期
  setUploadParam() {
    return new Promise((resolve, reject) => {
      let now = (this.timestamp = new Date().getTime());
      this.expire = Number(sessionStorage.getItem("expire"));
      if (this.expire < now + 3) {
        this.marketReportFile.getStsToken(this.stsParam).then(
          (res: any) => {
            this.ossClient.accessKeyId = res.data.accessKeyId;
            this.ossClient.accessKeySecret = res.data.accessKeySecret;
            this.ossClient.stsToken = res.data.securityToken;
            this.expire = new Date(res.data.expiration).getTime();
            sessionStorage.setItem("expire", String(this.expire));
            sessionStorage.setItem("ossClient", JSON.stringify(this.ossClient));
            resolve(200);
          },
          () => {
            reject(400);
          }
        );
      } else {
        resolve(200);
      }
    });
  }
  // 报告种类删除
  onDelete(row) {
    this.$confirm("此操作将删除该文件, 是否继续?", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    }).then(() => {
      this.tableloading = true;
      this.marketReportFile
        .deleteReportFile({ id: row.id })
        .then((res: any) => {
          this.tableloading = false;
          if (res.data) {
            this.$message({
              message: "删除成功",
              type: "success",
              center: true,
            });
            this.onQuery(false);
          } else {
            this.$message.error("删除失败");
          }
        })
        .catch((error) => {
          this.tableloading = false;
        });
    });
  }
  // 对话框关闭事件
  handleClose() {
    if (this.isCreate) {
      this.addDataDetail = new AddDataDetail();
    } else {
      this.addDataDetail.reUploadFile = false;
      this.addDataDetail.reUploadPic = false;
    }
    this.picFile = null;
    this.pdfFile = null;
    this.reportType = 0;
    this.$refs.ReportListForm.resetFields();
  }
  // 日期选择时分解单个字串为beginCreateTime、endCreateTime
  onPickChange() {
    if (this.rangeTime != null && this.rangeTime.length > 0) {
      this.queryForm.beginTime = this.rangeTime[0];
      this.queryForm.endTime = this.rangeTime[1];
    } else {
      this.queryForm.beginTime = "";
      this.queryForm.endTime = "";
    }
  }
  // 报告列表分页页容量变化事件
  onPageSizeChange(val) {
    this.queryForm.pageSize = val;
    this.queryForm.currentPageIndex = 1;
    this.onQuery(false);
  }
  // 报告列表分页页码变化事件
  onPageIndexChange(val) {
    this.queryForm.currentPageIndex = val;
    this.onQuery(false);
  }
  //格式化日期
  formatDate(time) {
    if (time == "") {
      return "";
    }
    let date = new Date(time);
    return formatDate(date, "yyyy-MM-dd hh:mm:ss");
  }
  reportTypeChange(val) {
    if (val === 1) {
      this.addDataDetail.reUploadFile = false;
    }
  }
}
